import { Paragraph5 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import * as ST from './styled';

const TooltipText = (): JSX.Element => {
    return (
        <ListContainer $size={4} $direction={'column'}>
            <Paragraph5 $color={COLORS.TextWhite}>
                Из&nbsp;чего складывается сумма:
            </Paragraph5>
            <ST.List>
                <li>положительный остаток на&nbsp;балансе</li>
                <li>начисления по&nbsp;тарифу за&nbsp;текущий месяц</li>
                <li>начисления за&nbsp;всё, что не&nbsp;входит в&nbsp;тариф:
                    <span>подписки, пакеты каналов, рассрочка</span>
                    <span>и&nbsp;аренда оборудования.</span>
                    <span>Расчёт идёт с&nbsp;учётом срока абонемента &mdash;</span>
                    <span>за&nbsp;3, 6&nbsp;или 12&nbsp;месяцев</span>
                </li>
                <li>остаток долга</li>
            </ST.List>
        </ListContainer>
    );
};

export default TooltipText;
